(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bkp-bag-builder"] && !Shopify.designMode) return;
  try {
    
function initializeBkpBuilders(root=document){
  root.querySelectorAll('[data-bkp-builder]').forEach(builder=>{
    if(builder.dataset.initialized)return;
    builder.dataset.initialized='true';
    const variants=JSON.parse(builder.querySelector('[data-variants]').textContent);
    const form=builder.querySelector('form');
    const button=form.querySelector('[type="submit"]');
    const idInput=form.querySelector('[name="id"]');
    const summary=builder.querySelector('[data-selected]');
    const status=builder.querySelector('[data-status]');
    const assets=JSON.parse(builder.querySelector('[data-preview-assets]').textContent);
    const preview=builder.querySelector('[data-preview]');
    const previewDescription=builder.querySelector('[data-preview-description]');
    const layers=['bag','scarf','charm'].map(name=>builder.querySelector('[data-preview-'+name+']'));
    const params=new URLSearchParams(window.location.search);
    ['bag','scarf','charm'].forEach((name,index)=>{
      const value=params.get('bkp_'+name);
      const field=builder.querySelectorAll('fieldset')[index];
      if(value&&field){const input=[...field.querySelectorAll('[data-choice]')].find(item=>item.value===value);if(input)input.checked=true;}
    });
    function setLayer(image,url){
      if(!url){image.hidden=true;image.removeAttribute('src');return;}
      if(image.getAttribute('src')!==url){
        image.hidden=true;
        image.onload=()=>{image.hidden=false;};
        image.onerror=()=>{image.hidden=true;};
        image.src=url;
      }
    }
    function update(){
      const checked=[...builder.querySelectorAll('fieldset')].map(field=>field.querySelector('input:checked'));
      const values=checked.map(input=>input?.value);
      const variant=variants.find(item=>item.options.every((value,index)=>value===values[index]));
      idInput.value=variant?.id||'';
      button.disabled=!variant?.available;
      status.textContent=variant?.available?builder.dataset.ready:builder.dataset.unavailable;
      const bagSource=checked[0]?.nextElementSibling.querySelector('img')?.getAttribute('src');
      setLayer(layers[0],bagSource?bagSource.replace(/width=\d+/,'width=600'):null);
      setLayer(layers[1],assets.scarves[values[1]]);
      setLayer(layers[2],assets.charms[values[2]]);
      setLayer(builder.querySelector('[data-preview-charm-star]'),assets.charms[values[2]]);
      preview.dataset.bag=values[0]||'';
      preview.dataset.charm=values[2]||'';
      const description=values.filter(Boolean).join(' + ');
      preview.setAttribute('aria-label',description);
      previewDescription.textContent=description;
      summary.replaceChildren();
      checked.forEach(input=>{
        if(!input)return;
        const label=input.nextElementSibling;
        const item=document.createElement('div');
        item.className='bkp-builder__selected-item';
        const source=label.querySelector('img');
        if(source){const img=source.cloneNode();img.removeAttribute('srcset');img.removeAttribute('sizes');item.append(img);}
        const text=document.createElement('span');text.textContent=input.value;item.append(text);summary.append(item);
      });
    }
    form.addEventListener('change',event=>{if(event.target.matches('[data-choice]'))update();});
    form.addEventListener('submit',event=>{update();if(button.disabled){event.preventDefault();status.focus();}});
    update();
  });
}
initializeBkpBuilders();
document.addEventListener('shopify:section:load',event=>initializeBkpBuilders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
